<template>
  <div class="dis-result">
    <div class="i-menu">
      <div class="iterm-l web-iterm quickTool" @click.stop.prevent="quickFile=!quickFile">
        快速引入
        <div class="drop-down-content" v-show="quickFile">
          <div @click.stop.prevent="quickTool()">
            <a href="javascript:;">基础代码模版</a>
          </div>
        </div>                 
      </div>
      <ul>
        <li :class="{active: index == n}" v-for="(item, index) in menus" @click="toggle(index)">{{item.name}}</li>
      </ul>
      <div class="run" v-if="compileBtn">
        <div class="click-run" @click="compile"></div>
      </div>
    </div>
    <div class="i-content">
      <div class="tab stdin-wrap" v-if="n==0">
        <input class="effect-2" type="text" placeholder="标准输入" v-model="standand" @keyup="inputParam">
        <span class="focus-border"></span>
      </div>
      <div class="tab" v-if="n==1">
        <pre class="compile-info" v-html="conetent"></pre>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import IO from 'socket.io-client'
import { ajaxAPI } from '@/utils/ajaxUtil'
import { API_URL, url } from '@/config/url_config'
import { getCompileResult } from '@/api/getCompileResult'
import EventBus from '@/views/eventBus'
export default {
  props: {
    options: {
      type: Object,
      default: function() {
        return {
          isLive: false, // 是否需要直播同步，默认不同步
          isCompile: true,
          infoCome: 'local', // 编译信息来源，local：本地，online：线上
          items: [
            {library: '图片'},
            {library: 'jQuery.js'},
            {library: 'Bootstrap.js'},
            {library: 'Bootstrap.css'}
          ],
        }
      }
    }
  },
  data () {
    return {
      roomId: this.$route.params.roomId,
      languageId: this.$route.params.languageId,
      menus: [
        {name: '标准输入'},
        {name: '运行结果'}
      ],
      n: 0,
      standand: '',
      conetent: '',
      compileBtn: true,
      quickFile: false
    }
  },
  created () {
  },
  watch: {
  },
  mounted () {
    this.initPlaySocket()
    let _this = this
    EventBus.$on('clearResult', function() {
      _this.conetent = ''
      let compileData = {
        code: '',
        langid: _this.$route.params.languageId,
        input: _this.standand,
        userId: Math.floor(Math.random() * 10000)
      }
      getCompileResult(compileData).then((data) => {
        console.log('compileData====', data)
        this.compileResult(data)
        
        if (_this.options.isLive) {
          _this.socket.emit('compile.result', data, _this.roomId)
        }
      })
    })
  },
  methods: {
    initPlaySocket() {
      this.compileBtn = this.options.isCompile
      if (this.options.infoCome === 'online') {
        this.socket.on('compile.result', (msg) => {
          console.log('compile.result', msg)
          this.compileResult(msg)
        })
        this.socket.on('check.tab', (data) => {
          console.log('check.tab:', data)
          this.n = data
        })
        this.socket.on('input.param', (data) => {
          console.log('input.param:', data)
          this.standand = data
        })
      }
    },
    toggle (index) {
      this.n = index
      if (this.options.isLive) {
        console.log('000')
        this.socket.emit('check.tab', index, this.$route.params.roomId)
      }
    },
    inputParam () {
      if (this.options.isLive) {
        console.log('isCompile1', this.options.isLive)
        this.socket.emit('input.param', this.standand, this.roomId)
      } else {
        console.log('isCompile2', this.options.isLive)
        return false
      }
    },
    compile () {
      let _this = this
      let compileData = {
        code: this.$store.state.editorContent || '',
        langid: this.$route.params.languageId,
        input: this.standand,
        userId: Math.floor(Math.random() * 10000)
      }
      console.log(this.$store.state.editorContent)
      getCompileResult(compileData).then((data) => {
        console.log('compileData====', data)
        this.compileResult(data)
        
        if (this.options.isLive) {
          _this.socket.emit('compile.result', data, this.roomId)
        }
      })
      // ajaxAPI('POST', API_URL + '/submit/submitCode/api', compileData).then(data => {
      //   console.log(data)
      //   this.compileResult(data)
      //   if (this.options.role === 0) {
      //     _socket.emit('compile.result', data, this.roomId)
      //   }
      // })
    },
    compileResult (data) {
      console.log(data)
      if (data.status === 200) {
        if (data.data.cmpinfo !== '') {
          this.n = 1
          this.conetent = data.data.cmpinfo
        } else if (data.data.stderr !== '') {
          this.n = 1
          this.conetent = data.data.stderr
        } else if (data.data.output !== '') {
          this.n = 1
          this.conetent = data.data.output
          console.log(this.conetent)
        } else {
          this.conetent = ''
        }
      } else {
        this.n = 0
      }
    },
    quickTool() {
      console.log('languageId', this.$route.params.languageId)
      this.quickFile = false
      this.$emit('insertTemplate', this.$route.params.languageId)
    }
  }
}
</script>

<style lang="scss" scoped>
.dis-result{
  width: 100%;
  height: 100%;
  background: #fff;
  
  .active{
    color: #FFF;
    background-image: -webkit-linear-gradient(left, #1FB6FF 0%, #62DCF5 100%);
    background-image: linear-gradient(to right, #1FB6FF 0%, #62DCF5 100%);
    -webkit-transition: 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275) all !important;
    transition: 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275) all !important;
    box-shadow: 0px 0px 2px 0px #B3E5FF;
    border: none;
    border-radius: 30px
  }
  .i-menu{
    box-sizing: border-box;
    height: 40px;
    background: rgba(31, 182, 255, .1);
    display: flex;
    color: #1FB6FF;
    padding: 4px 0;
    padding-left: 30px;

    ul{
      flex: 1;
      padding-top: 3px;
      text-align: center;
    }
    li{
      float: left;
      padding:0 15px;
      height: 28px;
      text-align: center;
      line-height: 30px;
      list-style: none;
      margin-right:2px;
      cursor: pointer;
      font-weight: 400;

      &:hover{
        color: #FFF;
        background-image: -webkit-linear-gradient(left, #1FB6FF 0%, #62DCF5 100%);
        background-image: linear-gradient(to right, #1FB6FF 0%, #62DCF5 100%);
        -webkit-transition: 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275) all !important;
        transition: 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275) all !important;
        box-shadow: 0px 0px 2px 0px #B3E5FF;
        border: none;
        border-radius: 30px
      }
    }
    .run{
      text-align: right;
      padding-top: 1px;
      padding-right: 24px;
      line-height: 36px;

      .compile-btn{
        padding: 4px 18px;
      }
    }
  }
  .i-content{
    width: 100%;
    height: calc(100% - 36px);
    box-sizing: border-box;
    background-color: #fff;
    overflow: hidden;
    .tab{
      width: 100%;
      height: 100%;
      box-sizing: border-box;
      padding: 8px 12px;
      overflow: auto;

      .compile-info{
        color: red;
      }
    }
    .stdin-wrap{
      :focus{
        outline: none;
      }
      input[type="text"]{
        color: #333; 
        width: 100%; 
        box-sizing: border-box; 
        letter-spacing: 1px;
      }
      .effect-2{
        border: 0; 
        padding: 7px 0; 
        border-bottom: 1px solid #ccc;
      }
      .effect-2 ~ .focus-border{
        position: absolute; 
        bottom: 0; 
        left: 50%; 
        width: 0; 
        height: 2px; 
        background-color: #3399FF; 
        transition: 1s;
      }
      .effect-2:focus ~ .focus-border{
        width: 100%; 
        transition: 1s; 
        left: 0;
      }
    }
  }
} 
</style>



// WEBPACK FOOTER //
// index.vue?cc1061c2